const idMail = 'idadvanced@gmail.com';
const idOff = 'idadvanced.office@gmail.com';
const requestApt = 'For AIDC appointments';
const idContact = '+17322302828';
const idNo = '732-230-2828';
export { requestApt, idMail, idOff, idContact, idNo };
